import { render, staticRenderFns } from "./BaseCamera.vue?vue&type=template&id=02565a86"
import script from "./BaseCamera.vue?vue&type=script&lang=js"
export * from "./BaseCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports